@if (initialized && formGroup) {

  <ng-container *ngIf="activeStep == 1">
    <forget-password-request [formGroup]="formGroup"
                                     (onStepComplete)="handleStepComplete($event)">
    </forget-password-request>
  </ng-container>

  <ng-container *ngIf="activeStep == 2">
    <forget-password-otp [formGroup]="formGroup"
                         (onStepComplete)="handleStepComplete($event)">
    </forget-password-otp>
  </ng-container>

  <ng-container *ngIf="activeStep == 3">
    <forget-password-change-password [formGroup]="formGroup"
                                     (onStepComplete)="handleStepComplete($event)">
    </forget-password-change-password>
  </ng-container>

}
